import { Box, styled, SxProps } from '@mui/material';
import theme from '../../theme';

export const tableStyles: SxProps = {
  '&.MuiTableContainer-root': {
    '&:not(:has(+ p)):not(:has(+ .MuiBox-root))': {
      '& .MuiTable-root': {
        '& .MuiTableBody-root': {
          '& .MuiTableRow-root:last-of-type': {
            [theme.breakpoints.down('md')]: {
              borderBottomColor: 'transparent',
            },
          },
        },
      },
    },
    overflowX: 'unset',
  },

  '& .MuiTable-root': {
    borderCollapse: 'collapse',
    overflowX: 'auto',
    overflowY: 'auto',
  },
};

export const tableHeaderStyles: SxProps = {
  '&.MuiTableHead-root': {
    position: 'sticky',
    top: 0,
    zIndex: 999,
    borderBottom: 'inherit',
    borderBottomColor: theme.palette.primary.contrastText,
    '& .MuiTableRow-root': {
      '& .MuiTableCell-root.MuiTableCell-head.MuiTableCell-sizeMedium': {
        paddingLeft: '16px',
      },

      '&#custom-first-row': {
        borderBottom: '1px solid',
        borderBottomColor: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.background.paper,
        '& > th': { backgroundColor: 'unset' },
      },
    },
  },
};

export const tableBodyStyles = (customFirstRow = false): SxProps => {
  return {
    '&.MuiTableBody-root': {
      '& .MuiTableRow-root': {
        backgroundColor: 'inherit',
        py: { xs: '0.2em' },
        borderBottom: '1px solid',
        borderBottomColor: theme.palette.primary.contrastText,

        [`&:nth-of-type(${customFirstRow ? 'even' : 'odd'})`]: {
          borderBottom: 'none',
        },
      },

      'tr > td': {
        border: 'none',
        '&.menu-items': {
          p: { xs: 0, md: 1 },
        },

        '& .MuiInputBase-root': {
          height: {
            xs: '40px',
          },
        },
      },
    },
  };
};

export const tableCellStyles: SxProps = {
  backgroundColor: theme.palette.secondary.light,
  '&.MuiTableBody-root &:last-child': {
    backgroundColor: theme.palette.secondary.light,
  },
};

export const StyledBox = styled(Box)(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(1.5),
    marginRight: theme.spacing(5),
    marginBottom: theme.spacing(1),

    [theme.breakpoints.down('md')]: {
      marginRight: 0,
    },
  };
});
